import { graphql, Link, useStaticQuery } from "gatsby";
import React, { useEffect, useState } from "react";
import * as s from "./header-banner.module.css";

const HeaderBanner = () => {

  const {
    wp: { acfOptionsHeader: { acfHeaderBanner: { headerBanner } } },
  } = useStaticQuery(graphql`
    query MyOptionsheaderBannerQuery {
      wp {
        acfOptionsHeader {
          acfHeaderBanner {
            headerBanner {
              show
              title
              link {
                target
                title
                url
              }
            }
          }
        }
      }
    }
  `);

  const [show, setShow] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      if (!!headerBanner?.show) {
        let bannerClosed = JSON.parse(sessionStorage.getItem('headerBannerClosed'));
        if (!!bannerClosed) {
          setShow(false);
        } else {
          setShow(true);
        }
      } else {
        setShow(false);
      }
    }, 5000);
  }, []);

  const closeBanner = () => {
    sessionStorage.setItem('headerBannerClosed', JSON.stringify(true));
    setShow(false);
  }

  const handleLinkClick = () => {
    sessionStorage.setItem('headerBannerClosed', JSON.stringify(true));
    setShow(false);
  }

  return (
    <>
      {!!headerBanner?.show &&
        <div className={`${s.banner} ${show ? s.show : ''}`} >
          <div className="container position-relative">
            <div type="button" className={s.close} onClick={closeBanner}>
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none">
                <path d="M9.94867 11.8484L6.01379 7.44822L2.21844 11.8484H0.15332L5.06495 6.38818L0.209134 0.927979H2.41379L6.29286 5.26814L10.0603 0.927979H12.0975L7.24169 6.32818L12.1533 11.8484H9.94867Z" fill="#ffffff" />
              </svg>
            </div>
            <div className="d-flex flex-wrap align-items-center justify-content-center" style={{ gap: '10px' }}>
              <div className={s.title}>{headerBanner?.title}</div>
              {!!headerBanner?.link?.url && <Link onClick={handleLinkClick} className={s.link} target={headerBanner?.link?.target} to={headerBanner?.link?.url}>
                {headerBanner?.link?.title}
              </Link>}
            </div>
          </div>
        </div>
      }
    </>
  );
};

export default HeaderBanner;